import "../index.css";
import HomePage from "../Layouts/Partials/homepage";
const Home = () => {
    return (<>
     <HomePage />
    </>
     ) 
  };
  
  export default Home;